import moment from "moment";

export const uiState = {
// Change this to your user ID
  userId: "",
  driver: {
    first: "", middle: "", last: "", suffix: "",
    dob: "", ssn: "",
    DriverFirstNameTrunCode: "N", DriverMiddleNameTrunCode: "N", DriverLastNameTrunCode: "N",
    DriverFirstNameTranCode: "N", DriverMiddleNameTranCode: "N", DriverLastNameTranCode: "N"
  },
  license: { country: "US", state: "", number: "" },
  akaList: [
    {
      AkaFirstName: "", AkaMiddleName: "", AkaLastName: "",
      DriverAkaDOB: "", Suffix: "",
      AkaFirstNameTrunCode: "N", AkaMiddleNameTrunCode: "N", AkaLastNameTrunCode: "N",
      AkaFirstNameTranCode: "N", AkaMiddleNameTranCode: "N", AkaLastNameTranCode: "N"
    },
    {
      AkaFirstName: "", AkaMiddleName: "", AkaLastName: "",
      DriverAkaDOB: "", Suffix: "",
      AkaFirstNameTrunCode: "N", AkaMiddleNameTrunCode: "N", AkaLastNameTrunCode: "N",
      AkaFirstNameTranCode: "N", AkaMiddleNameTranCode: "N", AkaLastNameTranCode: "N"
    },
  {
    AkaFirstName: "", AkaMiddleName: "", AkaLastName: "",
    DriverAkaDOB: "", Suffix: "",
    AkaFirstNameTrunCode: "N", AkaMiddleNameTrunCode: "N", AkaLastNameTrunCode: "N",
    AkaFirstNameTranCode: "N", AkaMiddleNameTranCode: "N", AkaLastNameTranCode: "N"
  }
  ],
  vehicle: { vin: "", rfc: "", plate: "" },

  search: {
    age: "", yearSearchRange: "", firstMatchSequence: "", messageMatchCount: ""
  }
};

const _cache = {
  aka: null,                      // { key, response, messages, transactionID }
  history: new Map(),             // key -> { response, messages, transactionID }
};

export let isTestEnv = false;
export function setIsTestEnv(value){
  console.log("Inside set:", value)
  isTestEnv = value;
}

export function cacheAka({ key, response }) {
  _cache.aka = {
    key,
    response,
    messages: response?.Messages || [],
    transactionID: response?.TransactionGUID
  };
}
export function readAkaCache(key) {
  return _cache.aka && _cache.aka.key === key ? _cache.aka : null;
}
export function clearAkaCache() { _cache.aka = null; }
export function cacheMinimal({ key, response }) {
  _cache.minimal = {
    key,
    response,
    request: response?.RequestKey?.Body?.DriverRequest?.DriverLicense?.LicenseState,
    messages: response?.Messages || [],
    transactionID: response?.TransactionGUID
  };
}
export function readMinimalCache(key) {
  return _cache.minimal && _cache.minimal.key === key ? _cache.minimal : null;
}
export function clearMinimalCache() { _cache.minimal = null; }
export function cacheHistory({ key, response }) {
  _cache.history.set(key, {
    response,
    messages: response?.Messages || [],
    transactionID: response?.TransactionGUID
  });
}
export function readHistoryCache(key) {
  return _cache.history.get(key) || null;
}
export function clearHistoryCache(key) {
  if (key) _cache.history.delete(key); else _cache.history.clear();
}

export let formData = makeFormDataFromUI(uiState);
function makeFormDataFromUI(s) {
  return {
    Header: { Metadata: { UserID: s.userId } },
    Body: {
      DriverRequest: {
        DriverLicense: {
          LicenseCountry: s.license.country || "US",
          LicenseState: s.license.state,
          LicenseNumber: s.license.number
        },
        DriverData: {
          DriverLicense: {
            LicenseCountry: s.license.country || "US",
            LicenseState: s.license.state,
            LicenseNumber: s.license.number
          },
          DriverName: {
            DriverFirstName: s.driver.first,
            DriverMiddleName: s.driver.middle,
            DriverLastName: s.driver.last,
            DriverFirstNameTrunCode: s.driver.DriverFirstNameTrunCode,
            DriverMiddleNameTrunCode: s.driver.DriverMiddleNameTrunCode,
            DriverLastNameTrunCode: s.driver.DriverLastNameTrunCode,
            DriverFirstNameTranCode: s.driver.DriverFirstNameTranCode,
            DriverMiddleNameTranCode: s.driver.DriverMiddleNameTranCode,
            DriverLastNameTranCode: s.driver.DriverLastNameTranCode,
            Suffix: s.driver.suffix
          },
          DriverDOB: s.driver.dob,
          SSN: s.driver.ssn,
          DriverNameAka: s.akaList
        },
        // Optional tuning fields
        Age: s.search.age,
        YearSearchRange: s.search.yearSearchRange,
        FirstMatchSequence: s.search.firstMatchSequence,
        MessageMatchCount: s.search.messageMatchCount
      },
      VehicleRequest: {
        VIN: s.vehicle.vin,
        RFC: s.vehicle.rfc,
        PLATE: s.vehicle.plate
      }
    }
  };
}
function syncFormData() {
  formData = makeFormDataFromUI(uiState);
}

function buildAkaPayload(s = uiState) {
  return {
    Header: { Metadata: { UserID: s.userId } },
    Body: {
      DriverRequest: {
        DriverData: {
          DriverLicense: {
            LicenseState: s.license.state,
            LicenseNumber: s.license.number
          },
          DriverName: {
            Suffix: s.driver.suffix,
            DriverFirstName:  s.driver.first,
            DriverMiddleName: s.driver.middle,
            DriverLastName:   s.driver.last,
            DriverFirstNameTrunCode: s.driver.DriverFirstNameTrunCode,
            DriverMiddleNameTrunCode:s.driver.DriverMiddleNameTrunCode,
            DriverLastNameTrunCode:  s.driver.DriverLastNameTrunCode,
            DriverFirstNameTranCode: s.driver.DriverFirstNameTranCode,
            DriverMiddleNameTranCode:s.driver.DriverMiddleNameTranCode,
            DriverLastNameTranCode:  s.driver.DriverLastNameTranCode
          },
          DriverDOB: s.driver.dob,
          SSN: s.driver.ssn,
          DriverNameAka: s.akaList
        }
      }
    }
  };
}

function buildDriverCommonPayload(s = uiState, opts = {}) {
  // History / Inquiry / Status share this shape
  console.log("Building driver common payload with options:", opts);
  const base = {
    Header: { Metadata: { UserID: s.userId } },
    Body: {
      DriverRequest: {
        DriverLicense: {
          LicenseCountry: s.license.country || "US",
          LicenseState:   s.license.state,
          LicenseNumber:  s.license.number
        },
      }
    }
  };
  if (!opts.licenseOnly) {
    console.log("Adding driver data to payload");
  base.Body.DriverRequest.DriverData = {
    DriverName: {
      Suffix: s.driver.suffix,
      DriverFirstName:  s.driver.first,
      DriverMiddleName: s.driver.middle,
      DriverLastName:   s.driver.last,
      DriverFirstNameTrunCode: s.driver.DriverFirstNameTrunCode,
      DriverMiddleNameTrunCode:s.driver.DriverMiddleNameTrunCode,
      DriverLastNameTrunCode:  s.driver.DriverLastNameTrunCode,
      DriverFirstNameTranCode: s.driver.DriverFirstNameTranCode,
      DriverMiddleNameTranCode:s.driver.DriverMiddleNameTranCode,
      DriverLastNameTranCode:  s.driver.DriverLastNameTranCode
    },
    DriverDOB: s.driver.dob,
    SSN: s.driver.ssn
  };
}
return base;
}

function buildVehiclePayload(s = uiState) {
  return {
    Header: { Metadata: { UserID: s.userId } },
    Body: {
      VehicleRequest: {
        VIN: s.vehicle.vin, RFC: s.vehicle.rfc, PLATE: s.vehicle.plate
      }
    }
  };
}

function buildMinimalPayload(s = uiState) {
  return {
    Header: { Metadata: { UserID: s.userId } },
    Body: {
      DriverRequest: {
        DriverLicense: {
          LicenseCountry: "US",
          LicenseState:   s.license.state,
        },
        DriverData: {
          DriverName: {
            Suffix: s.driver.suffix,
            DriverFirstName:  s.driver.first,
            DriverMiddleName: s.driver.middle,
            DriverLastName:   s.driver.last,
            DriverFirstNameTrunCode: s.driver.DriverFirstNameTrunCode,
            DriverMiddleNameTrunCode:s.driver.DriverMiddleNameTrunCode,
            DriverLastNameTrunCode:  s.driver.DriverLastNameTrunCode,
            DriverFirstNameTranCode: s.driver.DriverFirstNameTranCode,
            DriverMiddleNameTranCode:s.driver.DriverMiddleNameTranCode,
            DriverLastNameTranCode:  s.driver.DriverLastNameTranCode
          }
        },
        Age: s.search.age,
        YearSearchRange: s.search.yearSearchRange,
        FirstMatchSequence: s.search.firstMatchSequence,
        MessageMatchCount: s.search.messageMatchCount
      }
    }
  };
}

export async function responseData(endpoint, token, kind, opts = {}) {
    const pick =
    kind ??
    (endpoint.includes('/api/aka')     ? 'aka'     :
     endpoint.includes('/api/history') ? 'history' :
     endpoint.includes('/api/inquiry') || endpoint.includes('/api/fcwd-only') ? 'inquiry' :
     endpoint.includes('/api/status')  ? 'status'  :
     endpoint.includes('/api/vehicle') ? 'vehicle' : 'minimal');

     console.log(`Requesting ${pick} data from ${endpoint}`);
  const payload =
    pick === 'aka'     ? buildAkaPayload(uiState) :
    pick === 'vehicle' ? buildVehiclePayload(uiState) :
    pick === 'minimal' ? buildMinimalPayload(uiState) :
                         buildDriverCommonPayload(uiState, opts);
    
    console.log("Requesting data payload:", payload);
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
    credentials: 'include',
  });

  const contentType = res.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const data = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const messages = Array.isArray(data?.Messages)
      ? data.Messages
      : typeof data === 'string' && data.trim().length > 0
        ? [data]
        : [res.statusText || 'The request could not be completed. Please try again.'];

    throw new Error(messages.join(' '));
  }

  return data;
}

export async function driverPhotoURL(url){
  try{
    const res = await fetch('/api/img-proxy?url=' + encodeURIComponent(url), {
      method: 'GET',
      headers: {
        Accept: "image/*"
      },
      cache: "no-store"
    });
    console.log("Driver photo response:", res.status, res.statusText);

    if (!res.ok) {
      throw new Error(`Image fetch failed: ${res.status}`);
    }

    // Convert binary data → base64 → data URL (React-PDF safe)
    const blob = await res.blob();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result); // "data:image/jpeg;base64,..."
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.error("Driver photo fetch error:", err);
    return null;
  }
}
// ---------------------------------------------------------------------------
// Mutators (compatible with your existing imports)
// Each setter updates uiState and keeps formData in sync.
// ---------------------------------------------------------------------------
export function clearRequest() {
  uiState.userId = "";
  uiState.driver = { first: "", middle: "", last: "", suffix: "", dob: "", ssn: "",
    DriverFirstNameTrunCode: "N", DriverMiddleNameTrunCode: "N", DriverLastNameTrunCode: "N",
    DriverFirstNameTranCode: "N", DriverMiddleNameTranCode: "N", DriverLastNameTranCode: "N" };
  uiState.license = { country: "US", state: "", number: "" };
  uiState.akaList = uiState.akaList.map(() => ({
    AkaFirstName: "", AkaMiddleName: "", AkaLastName: "",
    DriverAkaDOB: "", Suffix: "",
    AkaFirstNameTrunCode: "N", AkaMiddleNameTrunCode: "N", AkaLastNameTrunCode: "N",
    AkaFirstNameTranCode: "N", AkaMiddleNameTranCode: "N", AkaLastNameTranCode: "N"
  }));
  uiState.vehicle = { vin: "", rfc: "", plate: "" };
  uiState.search = { age: "", yearSearchRange: "", firstMatchSequence: "", messageMatchCount: "" };
  syncFormData();
}

export function setUserId(userId) { uiState.userId = userId || "deandra.h"; syncFormData(); }

export function setLicenseCountry(v) { uiState.license.country = v || "US"; syncFormData(); }
export function setLicenseNumber(v) { uiState.license.number  = v.toUpperCase() || "";   syncFormData(); }
export function setLicenseState(v)   { uiState.license.state   = Array.isArray(v) ? v : v === null ? [] : v.toUpperCase() || "";   syncFormData(); }

export function setDriverFistName(v)    { uiState.driver.first  = v.toUpperCase() || ""; syncFormData(); }
export function setDriverMiddleName(v)  { uiState.driver.middle = v.toUpperCase() || ""; syncFormData(); }
export function setDriverLastName(v)    { uiState.driver.last   = v.toUpperCase() || ""; syncFormData(); }
export function setDriverSuffix(v)      { uiState.driver.suffix = v.toUpperCase() || ""; syncFormData(); }
export function setDriverDOB(v)         { uiState.driver.dob    = v || ""; syncFormData(); }
export function setDriverSSN(v)         { uiState.driver.ssn    = v || ""; syncFormData(); }

export function setDriverAge(v)             { uiState.search.age = v || ""; syncFormData(); }
export function setYearSearchRange(v)       { uiState.search.yearSearchRange = v || ""; syncFormData(); }
export function setFirstMatchSequence(v)    { uiState.search.firstMatchSequence = v || ""; syncFormData(); }
export function setMessageMatchCount(v)     { uiState.search.messageMatchCount = v || ""; syncFormData(); }

export function setVIN(v)   { uiState.vehicle.vin   = v.toUpperCase() || ""; syncFormData(); }
export function setRFC(v)   { uiState.vehicle.rfc   = v.toUpperCase() || ""; syncFormData(); }
export function setPlate(v) { uiState.vehicle.plate = v.toUpperCase() || ""; syncFormData(); }

// AKA helpers
export function updateAKAListData(list) { uiState.akaList = Array.isArray(list) ? list : []; syncFormData(); }
export function updateAKA(index, key, value) {
  if (!uiState.akaList[index]) return;
  if(moment(value).isValid()) {
    uiState.akaList[index][key] = moment(value).format("YYYY-MM-DD");
  }else {
    uiState.akaList[index][key] = value.toUpperCase();
  }
  syncFormData();
}
export function setTrunTran(field) {
  const fields = uiState.driver;
  const val = fields[field] || "";
  fields[field] = (val === "N" || val === "") ? "T" : "N";
  syncFormData();
  return fields[field];
}
export function setAkaTrunTran(index, field) {
  const row = uiState.akaList[index];
  if (!row) return;
  const val = row[field] || "";
  row[field] = (val === "N" || val === "") ? "T" : "N";
  syncFormData();
  return row[field];
}

// ---------------------------------------------------------------------------
// Error helpers & misc (compatible with your usage)
// ---------------------------------------------------------------------------
export let errorReceived = [];
export function setErrorReceived(errors) { console.log(errors); errorReceived = errors; }

export function getErrorMessage(error, fallback = 'The request could not be completed. Please try again.') {
  if (error == null) return fallback;

  if (typeof error === 'string') {
    const message = error.replace(/^ERROR:\s*/i, '').trim();
    return message || fallback;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message.replace(/^ERROR:\s*/i, '').trim();
  }

  if (Array.isArray(error?.Messages) && error.Messages.length > 0) {
    return error.Messages.join(' ');
  }

  if (typeof error?.response?.data?.Messages === 'string') {
    return error.response.data.Messages;
  }

  if (Array.isArray(error?.response?.data?.Messages) && error.response.data.Messages.length > 0) {
    return error.response.data.Messages.join(' ');
  }

  return fallback;
}

export let batchId = "";
export function setBatchId(id) { batchId = id; }

export const selectionRequest = { country: "", queryType: "", jurisdiction: "" };
export function setCountry(v){ selectionRequest.country = v || ""; }
export function setQueryType(v){ selectionRequest.queryType = v || ""; }
export function setJurisdiction(v){ selectionRequest.jurisdiction = v || ""; }

// ---------------------------------------------------------------------------
// Validation utilities (kept close to your previous signatures)
// ---------------------------------------------------------------------------
export function generateData(data) {
  // Collect keys whose value is exactly "INVALID" (legacy behavior)
  return Object.keys(data).reduce((result, key) => {
    const value = data[key];
    if (typeof value === "string") {
      if (value === "INVALID") {
        if (key === "LicenseNumber") return result;
        if (key === "DriverFirstName" && uiState.driver.first === "") return result;
        result.push(key);
      }
    } else if (value && typeof value === "object") {
      result.push(...generateData(value));
    }
    return result;
  }, []);
}

export function removeEmptyFields(obj) {
  const out = {};
  for (const k in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
    const v = obj[k];
    if (v === null || v === undefined || v === "") continue;
    out[k] = typeof v === "object" ? removeEmptyFields(v) : v;
  }
  return out;
}

export function removeEmptyObjects(o) {
  for (const k in o) {
    if (!o[k] || typeof o[k] !== "object") continue;
    removeEmptyObjects(o[k]);
    if (Object.keys(o[k]).length === 0) delete o[k];
  }
  return o;
}

export const isCompletelyEmpty = (obj) => {
  // 1. Handle primitives (null, undefined, empty string)
  if (obj === null || obj === undefined || obj === "") return true;

  // 2. Handle Arrays
  if (Array.isArray(obj)) {
    // Empty if array has no length OR every element in it is empty
    return obj.length === 0 || obj.every(item => isCompletelyEmpty(item));
  }

  // 3. Handle Objects
  if (typeof obj === "object") {
    const values = Object.values(obj);
    // Empty if no keys OR every value associated with a key is empty
    return values.length === 0 || values.every(v => isCompletelyEmpty(v));
  }

  return false;
};

// ---------------------------------------------------------------------------
// UI helpers used in your pages
// ---------------------------------------------------------------------------
export function CheckDACH({ dach }) {
  if (dach && dach.length > 0) {
    return (
      <>
        {dach.map((details, i) => (
          <div key={i}>
            {details.IsProhibited && (
              <div className="alert alert-danger" role="alert" style={{ fontSize: 'x-large' }}>
                <strong>DRUG AND ALCOHOL CLEARINGHOUSE - DRIVER IS PROHIBITED FROM OPERATING UNDER 382.501(A)</strong>
              </div>
            )}
          </div>
        ))}
      </>
    );
  }
  return null;
}

export function ErrorMessage(props) {
  // Accepts either { Message: "..."} or { value: "..." }
  const  raw = props?.Message ?? props?.value ?? props;
  if(raw === "DRUG AND ALCOHOL CLEARINGHOUSE - DRIVER IS PROHIBITED FROM OPERATING UNDER 382.501(A)"){
    return ;
  }

  return (
    <div role="alert" style={{ color: 'red' }}>
      <div dangerouslySetInnerHTML={{ __html: raw }} />
    </div>
  );
}

export function CheckMessages(message){
  let NewMsg = []
  message.map((v, i)=> {

    if(i !== message.length-1){
      v += "; " 
    }
    NewMsg.push(v)

    /*

    if(v === "REQUESTED RECORD NOT FOUND"){
      NewMsg.push("REQUESTED RECORD NOT FOUND; ")
     } else {
      NewMsg.push(v)
    }

    if(v === "NOT ALLOWED TO DRIVE IN USA") {
      NewMsg.push("NOT ALLOWED TO DRIVE IN USA; ")
    } else {
      NewMsg.push(v)
    }
      */
  })
  return NewMsg;
}
